import GalleryController from './Controller/GalleryController';

$(document).ready(function () {
  new GalleryController();
});
